import { PartialDeep } from 'type-fest';

import { translate } from 'services/i18nService';
import { Theme } from 'themes/themes.types';
import UserStore from 'stores/UserStore';
import { removeEmpty } from 'themes/utils';


const TRANSLATION_NOT_FOUND = '$not_found$';

export const prepareLine = (translationBundle: string, translationKey: string, placeholders: string[]) => {
  let result = undefined;

  if (translationKey) {
    if (translationBundle) {
      result = translate(
        `${translationBundle}.${translationKey}`,
        placeholders ? { ...placeholders.slice() } : undefined,
        TRANSLATION_NOT_FOUND
      );
    }

    if (!result || result === TRANSLATION_NOT_FOUND) {
      result = translate(translationKey, placeholders ? { ...placeholders.slice() } : undefined);
    }
  }

  return result;
};

export default class Overrides {
  get theme(): PartialDeep<Theme> {
    const { user: { activeCampaigns } } = UserStore;
    const activeCampaign = activeCampaigns?.[0];
    const { assets } = activeCampaign || {};
    const { translationBundle } = assets || {};

    // Allow to change the text by campaign assets object

    const onCamAnimation = assets?.onCamAnimation ? {
      onCamAnimation: removeEmpty<Partial<Theme['onCamAnimation']>>({
        delay: assets.onCamAnimation.delay || assets.onCamAnimation.timeOut,
        line1Text:
          prepareLine(translationBundle, assets.onCamAnimation.line1, assets.onCamAnimation.line1Placeholders),
        line2Text:
          prepareLine(translationBundle, assets.onCamAnimation.line2, assets.onCamAnimation.line2Placeholders),
        line3Text:
          prepareLine(translationBundle, assets.onCamAnimation.line3, assets.onCamAnimation.line3Placeholders),
      }),
    } : {};

    const headerCTA = assets?.headerCTA ? {
      headerCTA: removeEmpty<Partial<Theme['headerCTA']>>({
        title:
          prepareLine(translationBundle, assets.headerCTA.text, assets.headerCTA.textPlaceholders),
      }),
    } : {};

    const mobileOverlay = assets?.mobileOverlay ? {
      mobileOverlay: removeEmpty<Partial<Theme['mobileOverlay']>>({
        delay: assets.mobileOverlay.delay || assets.mobileOverlay.timeOut,
        title:
          prepareLine(translationBundle, assets.mobileOverlay.title, assets.mobileOverlay.titlePlaceholders),
        text:
          prepareLine(translationBundle, assets.mobileOverlay.text, assets.mobileOverlay.textPlaceholders),
      }),
    } : {};

    const buyTokensModal = assets?.buyTokensModal ? {
      buyTokensModal: removeEmpty<Partial<Theme['buyTokensModal']>>({
        title:
          prepareLine(translationBundle, assets.buyTokensModal.title, assets.buyTokensModal.titlePlaceholders),
        text:
          prepareLine(translationBundle, assets.buyTokensModal.subtitle, assets.buyTokensModal.subtitlePlaceholders),
      }),
    } : {};

    const infoStrip = assets?.infoStrip ? {
      infoStrip: removeEmpty<Partial<Theme['infoStrip']>>({
        title:
          prepareLine(assets.translationBundle, assets.infoStrip.title, assets.infoStrip.titlePlaceholders),
        text:
          prepareLine(assets.translationBundle, assets.infoStrip.text, assets.infoStrip.textPlaceholders),
      }),
    } : {};

    const chatOffer = assets?.chatOffer ? {
      chatOffer: removeEmpty<Partial<Theme['chatOffer']>>({
        delay: assets.chatOffer.delay || assets.chatOffer.timeOut,
        title:
          prepareLine(assets.translationBundle, assets.chatOffer.title, assets.chatOffer.titlePlaceholders),
        text:
          prepareLine(assets.translationBundle, assets.chatOffer.text, assets.chatOffer.textPlaceholders),
      }),
    } : {};

    return {
      ...onCamAnimation,
      ...headerCTA,
      ...mobileOverlay,
      ...infoStrip,
      ...buyTokensModal,
      ...chatOffer,
    };
  }
}

